<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`joins.input`]>
      <v-row no-gutters>
        <v-col cols="6">
          <joins-settings-list />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import JoinsSettingsList from '@/components/JoinsSettingsList';

export default {
  name: 'JoinsSettings',
  components: { AdminWrapper, JoinsSettingsList },
  computed: {
    additionalModuleName: get('admin/additionalModules@JOINS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@joins_module_enabled'),
    inputs() {
      return [
        {
          name: 'joins',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'joins_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getLayers: call('layers/getLayers'),
    getJoins: call('joins/getJoins'),
    async init() {
      await Promise.all([this.getJoins(), this.getLayers(), this.getDataSources({ with_attributes_schema: true })]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
